import name from './name'

const selectSliceData = state => state[name]

const selectAuthError = state => selectSliceData(state).authError

export { selectAuthError }
